<template>
    <div :class="{ 'has-file': showRemovedBtn }" class="c-file-input js-file-input has-file">
        <div v-if="!disabled" class="c-file-input__indicator" @click="selectFile">
            <span class="c-file-input__indicator__icon c-icon c-icon--attach">
                <i class="fas fa-upload"></i>
            </span>
        </div>
        <label class="c-file-input__label js-file-input__label" for="inputfile">
            <span>{{ theFileName }}</span>
            <input :disabled="disabled" ref="fileInput" type="file" @change="fileChangeHandler" :name="name"
                class="c-file-input__field js-file-input__field">
        </label>
        <div @click.stop="clearFileHandler" class="c-file-input__remove js-file-input__remove">
            <span v-if="!disabled" class="c-file-input__remove__icon c-icon c-icon--remove-circle">
                <i class="fas fa-minus-circle"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "slim-uploader",
    props: {
        name: {
            required: true
        },
        disabled: {
            type: Boolean
        },
        labelPlaceholder: {
            type: String,
            default: 'Upload file here',
        },
    },
    data() {
        return {
            value: '',
            files: [],
            showRemovedBtn: false,
        };
    },
    computed: {
        theFileName() {
            if ((this.files.length > 0) && 'name' in this.files[0]) {
                return this.files[0].name;
            }
            return this.labelPlaceholder;
        },
    },
    methods: {
        selectFile() {
            this.$refs.fileInput.click()  
        },
        fileChangeHandler(e) {
            this.files = Array.from(e.target.files);
            this.showRemovedBtn = true;
        },
        clearFileHandler() {
            const el = this.$el.querySelector('.js-file-input__field');
            const wrapper = document.createElement('form');
            this.wrapInputAndReset(el, wrapper);
        },
        wrapInputAndReset(el, wrapper) {
            // wrap input with form tag
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);

            // reset input with form.reset()
            wrapper.reset();

            // place childNodes in document fragment
            const docFrag = document.createDocumentFragment();
            while (wrapper.firstChild) {
                const child = wrapper.removeChild(wrapper.firstChild);
                docFrag.appendChild(child);
            }

            // replace wrapper with document fragment
            wrapper.parentNode.replaceChild(docFrag, wrapper);

            this.files = [];
            this.showRemovedBtn = false;
        },
    },
};
</script>

<style scoped>
.c-field__error {
    font-size: 12px;
    color: #d71149;
}

.c-file-input {
    cursor: pointer;
    position: relative;
    display: block;
    height: 36px;
    border: 1px solid #D1D1D1;
    background-color: #fff;
}

/* line 24, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input:invalid,
.c-field--error .c-file-input {
    background-color: #ffe6e9;
    border-color: #ff566a;
}

/* line 28, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input:invalid:focus,
.c-field--error .c-file-input:focus {
    background-color: #ffe6e9;
    border-color: #ff566a;
}

/* line 34, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-left: 6px;
    padding-right: 72px;
    line-height: 36px;
    color: #455666;
    font-size: 12px;
    overflow: hidden;
    word-wrap: break-word;
    z-index: 1;
}

/* line 50, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__field {
    position: absolute !important;
    height: 1px !important;
    width: 1px !important;
    padding: 0 !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    z-index: -1;
}

/* line 59, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__field:focus {
    outline: none;
}

/* line 64, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__indicator {
    position: absolute;
    right: 32px;
    top: 0;
    height: 100%;
    width: 14px;
    z-index: 2;
}

/* line 73, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__indicator__icon {
    color: #bbb;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    -o-transform: translate(0, -50%);
    transform: translate(0, -50%);
    left: 4px;
    font-size: 14px;
}

/* line 81, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.has-file .c-file-input__indicator__icon {
    color: #217FBD;
}

/* line 86, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__remove {
    display: none;
    position: absolute;
    top: 0;
    right: 8px;
    height: 100%;
    width: 14px;
    z-index: 2;
}

.has-file>.c-file-input__remove {
    display: block;
}

/* line 100, app/assets/stylesheets/mweb/6-components/_components.file-input.scss */
.c-file-input__remove__icon {
    position: absolute;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    -o-transform: translate(0, -50%);
    transform: translate(0, -50%);
    left: 1px;
    font-size: 14px;
    color: #217FBD;
}
</style>